import { render, staticRenderFns } from "./EscapeRoute.vue?vue&type=template&id=1b4ee189&scoped=true"
import script from "./EscapeRoute.vue?vue&type=script&lang=js"
export * from "./EscapeRoute.vue?vue&type=script&lang=js"
import style0 from "./EscapeRoute.vue?vue&type=style&index=0&id=1b4ee189&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4ee189",
  null
  
)

export default component.exports